<template>
  <div class="edit-style-border-radius">
      <label class="common-label">{{ labelText }}<span class="slider-value">{{ sliderValue }}</span></label>
    <input
      type="range"
      v-model="sliderValue"
      step="1"
      min="0"
      @change="updateSliderValue($event.target.value)"
    >
  </div>
</template>

<script>
export default {
  props: [
    'target',
    'unit',
    'value',
    'type',
    'attrs',
  ],
  data () {
    return {
      labelText: null,
      sliderValue: 0,
    }
  },
  mounted () {
    this.initLabelText()
    this.initSliderValue()
  },
  methods: {
    initLabelText () {
      this.labelText = '丸み'
    },
    updateSliderValue (value) {
      this.$emit('updateStyles', [{ prop: this.target, value: value + this.unit }])
    },
    initSliderValue () {
      this.sliderValue = this.value ? this.value.replace(/px/g, '').replace(/%/g, '') : '0'
    },
  },
}
</script>

<style lang="scss" scoped>
.edit-style-border-radius {
  position: relative;
  margin: 20px 0;
  .common-label {
    margin-bottom: 10px;
    .slider-value {
      display: inline-block;
      margin-left: 56px;
      width: 40px;
      height: 18px;
      line-height: 18px;
      border-radius: 15px;
      text-align: center;
      background: #fff;
    }
  }
  input[type="range"] {
    width: 300px;
  }
}
</style>
